<section class="contact-sec pt-5 pb-5" id="about">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2>
                    About <span>Us</span>
                </h2>
            </div>
            <div class="col-md-6">
                <img src="assets/images/enquiry-1.webp" class="img-fluid">
            </div>
            <div class="col-md-6">
                <p>
                    We are a ride-share service. We give anyone a ride who needs one. We do not just serve the Amish community, although we do provide Amish specific benefits like operators, who also speak Dutch. 
                </p>
                <a href="tel:330-474-9507 ">
                <button mat-raised-button class="call-now">
                    Call Now
                </button>
                </a>
            </div>
        </div>
    </div>
</section>